const slugify = (value) =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const mapWithSlug = (property) => ({
  ...property,
  slug: property.slug || slugify(property.name),
});

const getMapQuery = (property) => `${property.name}, ${property.address}, Norway`;

const createGoogleMapsEmbedUrl = (property) => {
  const query = encodeURIComponent(getMapQuery(property));
  return `https://www.google.com/maps?q=${query}&output=embed`;
};

const createGoogleMapsLink = (property) => {
  const query = encodeURIComponent(getMapQuery(property));
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};

export const propertyModel = {
  slugify,
  mapWithSlug,
  getMapQuery,
  createGoogleMapsEmbedUrl,
  createGoogleMapsLink,
};